import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	ChapterPageFilter,
	CreateChapterRequest,
	Information330Chapter,
	Information330ChapterDTO,
	Information330Overview,
	InformationDetailRequest,
	InformationListDTO,
	InformationPageFilter,
	PublishInformationDTO,
	SortInformationDTO,
} from '../DTO/information/information.interface';

export const informationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getInformationList: builder.query<
			SuccessResponse<Paginated<InformationListDTO>>,
			InformationPageFilter
		>({
			query: (body) => ({
				url: `/web/information/330-overview/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['InformationList'],
		}),
		sortInformation: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortInformationDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/330-overview/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['InformationList'],
		}),
		publishInformation: builder.mutation<
			SuccessResponse<any>,
			{ publishList: PublishInformationDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/330-overview/publish`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['InformationList', 'InformationDetail'],
		}),
		createInformation: builder.mutation<
			SuccessResponse<any>,
			InformationDetailRequest
		>({
			query: (body) => ({
				url: `/web/information/330-overview`,
				method: 'POST',
				body,
			}),
		}),
		informationDetail: builder.query<
			SuccessResponse<Information330Overview>,
			string
		>({
			query: (id) => ({
				url: `/web/information/330-overview/${id}`,
				method: 'GET',
			}),
			providesTags: ['InformationDetail'],
		}),
		updateInformation: builder.mutation<
			SuccessResponse<any>,
			InformationDetailRequest
		>({
			query: (body) => ({
				url: `/web/information/330-overview`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['InformationDetail'],
		}),
		deleteInformation: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/330-overview/${id}`,
				method: 'DELETE',
			}),
		}),
		getChapterList: builder.query<
			SuccessResponse<Paginated<Information330ChapterDTO>>,
			ChapterPageFilter
		>({
			query: (body) => ({
				url: `/web/information/330-chapter/page`,
				method: 'POST',
				body,
			}),

			providesTags: ['ChapterList'],
		}),
		createChapter: builder.mutation<SuccessResponse<any>, CreateChapterRequest>(
			{
				query: (body) => ({
					url: `/web/information/330-chapter`,
					method: 'POST',
					body,
				}),
			}
		),
		updateChapter: builder.mutation<SuccessResponse<any>, CreateChapterRequest>(
			{
				query: (body) => ({
					url: `/web/information/330-chapter`,
					method: 'PUT',
					body,
				}),
				invalidatesTags: ['ChapterDetail'],
			}
		),
		chapterDetail: builder.query<
			SuccessResponse<Information330Chapter>,
			string
		>({
			query: (id) => ({
				url: `/web/information/330-chapter/${id}`,
				method: 'GET',
			}),
			providesTags: ['ChapterDetail'],
		}),
		deleteChapter: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/330-chapter/${id}`,
				method: 'DELETE',
			}),
		}),
		sortChapter: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortInformationDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/330-chapter/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['ChapterList'],
		}),
	}),
});

export const {
	useGetInformationListQuery,
	useSortInformationMutation,
	usePublishInformationMutation,
	useCreateInformationMutation,
	useInformationDetailQuery,
	useUpdateInformationMutation,
	useDeleteInformationMutation,
	useGetChapterListQuery,
	useCreateChapterMutation,
	useChapterDetailQuery,
	useUpdateChapterMutation,
	useDeleteChapterMutation,
	useSortChapterMutation,
} = informationApiSlice;
